import IconAnalisisDeudaCliente from "../images/IconAnalisisDeudaCliente.png";
import IconAnalisisDeudaProveedores from "../images/IconAnalisisDeudaProveedores.png";
import FindInPageOutlinedIcon from "@material-ui/icons/FindInPageOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import TrendingUpOutlinedIcon from "@material-ui/icons/TrendingUpOutlined";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";

import { pathNamePages } from "./pathnames";

// Menú de dos niveles (por ahora fijo en el código, sin tablas en la base).
// seccionKey: Key de la sección de Analytics (tabla Secciones) que da acceso a la página.
//   28 analisisDeuda · 29 analisisDeudaAcreedores · 46 impresion · 47 impresionPedidos
//   48 impresionPresupuestos · 49 impresionCotizaciones · 50 impresionOrdenesCompra · 51 smartScan
// imgIcon (PNG) o icon (componente de ícono) para el ícono del menú.
// Un grupo se muestra sólo si el usuario tiene acceso a alguna de sus páginas.
export const menuGroups = [
  {
    name: "Ventas",
    icon: TrendingUpOutlinedIcon,
    pages: [
      {
        name: "Análisis deuda de cliente",
        uri: pathNamePages.analisisDeudaCliente,
        imgIcon: IconAnalisisDeudaCliente,
        seccionKey: "analisisDeuda",
      },
      {
        // La sección 46 se muestra en Ventas y en Compras; cada página trae sólo su circuito.
        name: "Ver comprobantes",
        uri: pathNamePages.impresionVentas,
        icon: FindInPageOutlinedIcon,
        seccionKey: "impresion",
      },
      {
        name: "Pedidos",
        uri: pathNamePages.pedidos,
        icon: AssignmentOutlinedIcon,
        seccionKey: "impresionPedidos",
      },
      {
        name: "Presupuestos",
        uri: pathNamePages.presupuestos,
        icon: DescriptionOutlinedIcon,
        seccionKey: "impresionPresupuestos",
      },
    ],
  },
  {
    name: "Compras",
    icon: ShoppingCartOutlinedIcon,
    pages: [
      {
        name: "Análisis deuda de proveedor",
        uri: pathNamePages.analisisDeudaProveedor,
        imgIcon: IconAnalisisDeudaProveedores,
        seccionKey: "analisisDeudaAcreedores",
      },
      {
        name: "Ver comprobantes",
        uri: pathNamePages.impresionCompras,
        icon: FindInPageOutlinedIcon,
        seccionKey: "impresion",
      },
      {
        name: "Cotizaciones",
        uri: pathNamePages.cotizaciones,
        icon: LocalOfferOutlinedIcon,
        seccionKey: "impresionCotizaciones",
      },
      {
        name: "Órdenes de compra",
        uri: pathNamePages.ordenesCompra,
        icon: ReceiptOutlinedIcon,
        seccionKey: "impresionOrdenesCompra",
      },
    ],
  },
  {
    name: "IA",
    icon: AutoAwesomeOutlinedIcon,
    pages: [
      {
        name: "CapturAI",
        uri: pathNamePages.smartScan,
        icon: AutoFixHighIcon,
        seccionKey: "smartScan",
      },
    ],
  },
];

// Lista plana de páginas, en el orden del menú (la primera accesible es la página inicial).
export const pagesInfo = menuGroups.flatMap((group) => group.pages);
